module.exports = __webpack_public_path__ + "img/15.d73e8e76.jpg";